
class CookieSetter {
    constructor() {
        const hostBlock = window.location.host.split('.');
        this.domain = hostBlock.filter((_, i) => i >= (hostBlock.length - 2)).join('.');
        if (window.location.host.includes('localhost') && this.domain.search(':') !== -1) {
            this.domain = 'localhost';
        }
        this._cookies = document.cookie;
    }

    setCookie(key, value, secondsToLive) {
        let date = new Date();
        date.setTime(date.getTime()+(1000*secondsToLive));
        document.cookie = `${key}=${value};domain=${this.domain}${secondsToLive ? ';path=/;expires=' + date.toGMTString() : ''}`;
    }

    getCookieValue(key){
        const cookieObject = document.cookie.split(';').map(_c => _c.replace(' ', '')).map(_c => _c.split('=')).reduce((p,c) => {
            p[c[0]] = c[1];
            return p;
        }, {});
        return cookieObject[key];
    }

    refreshCookie(key, secondsToLive){
        const value = this.getCookieValue(key);
        this.setCookie(key, value, secondsToLive);
    }

    deleteCookie(key){
        document.cookie = `${key}=;domain=${this.domain};expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
    }
}

export default (() => {
    const cS = new CookieSetter();
    return cS;
})();
